import * as React               from "react";

import "./social-panel.scss";

import {isApiTrue}      from "@Common/logic/is-api-true";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load}           from "@Common/react/load";
import {Load2}          from "@Common/react/load2";
import {UseState}       from "@Common/react/use-state";
import {plural}         from "@Common/ui-components/language/plural";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";

import {EmulationModal} from "../../../common/emulation-modal/emulation-modal";
import {AGENT_LEVEL,
        COMPANY_LEVEL } from "../../../common/logic/user-level";

import {SocialAccounts}  from "./social-accounts/social-accounts";
import {SocialDashboard} from "./social-accounts/social-dashboard/social-dashboard";

export const AccountSocialPanel = ({agentId=undefined}) => cs(
    consumeContext("session"),
    consumeContext("userLevels"),
    consumeContext("apis"),
    ["emulationModal", (_, next) => EmulationModal({next})],
    ["agent", ({session, apis}, next) => !agentId ? next(session?.data?.agent) : (
        Load({
            fetch: () => apis.next.session.getAgent({agentId}),
            next,
        })
    )],
    ["socialMediaStatus", ({apis}, next) => Load2({
        fetch: () => apis.next.social.getSocialMediaStatus(),
        next,
    })],
    ({agent, userLevels, emulationModal, apis, session, socialMediaStatus}) => (
        <div className="account-social-panel-f9y">
            {!agent || socialMediaStatus.loading ? (
                <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                    Loading...
                </div>
            ) : (agentId || agent?.idAgent && agent?.idAgent != "Branch Order") ? (
                <>
                <div className="section">
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="Linked Accounts">
                            Linked Accounts
                        </div>
                        <div className="sub-title" xd-qa-type="label" xd-qa-name="Sub Label">
                            {cs(
                                ["count", (_, next) => next(["facebook", "twitter", "linkedin"].filter((s) => socialMediaStatus.value[s]).length)],
                                ({count}) => (
                                    `You can currently link up to ${count} social ${plural("network", count)}`
                                ),
                            )}
                        </div>
                    </div>
                    <div className="box">
                        {agentId == null ? (
                            <div className="header">
                                {cs(
                                    ["sliderIsUpdating", (_, next) => UseState({defaultValue: false, next})],
                                    ({sliderIsUpdating}) => SliderCheckbox({
                                        disabled: sliderIsUpdating.value,
                                        value: isApiTrue(agent?.allowAdminsToShare),
                                        onChange: async () => {
                                            sliderIsUpdating.onChange(true);
                                            await apis.next.session.updateAgent({updateFields: {allowAdminsToShare: !agent?.allowAdminsToShare}});
                                            await session?.reload();
                                            sliderIsUpdating.onChange(false);
                                        },
                                        xdQaName: "Allow Admin " + isApiTrue(agent?.allowAdminsToShare)
                                    }),
                                )}
                                <div className="text" xd-qa-type="label" xd-qa-name="Allow administrators to post to your accounts on your behalf">
                                    Allow administrators to post to your accounts on your behalf
                                </div>
                            </div>
                        ) : (
                            <div className="header">
                                <div className="text" xd-qa-type="label" xd-qa-name={agent?.allowAdminsToShare ? ADMIN_ALLOWED : ADMIN_NOT_ALLOWED}>
                                    {
                                        agent?.allowAdminsToShare
                                        ?
                                        ADMIN_ALLOWED
                                        :
                                        ADMIN_NOT_ALLOWED
                                    }
                                </div>
                            </div>
                        )}
                        {
                            (userLevels.userLevel === AGENT_LEVEL || agent?.allowAdminsToShare) 
                            ?
                            SocialAccounts({socialMediaStatus: socialMediaStatus.value, agentId})
                            : 
                            null
                        }
                    </div>
                </div>
                <div className="section social">
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="Social Dashboard">
                            Social Dashboard
                        </div>
                        <div className="sub-title" xd-qa-type="label" xd-qa-name={MESSAGE_VIEW_METRICS}>
                            {MESSAGE_VIEW_METRICS}
                        </div>
                    </div>
                    <div className="box">
                        <SocialDashboard idEntity={agentId} socialMediaStatus={socialMediaStatus.value} />
                    </div>
                </div>
                </>
            ) : (
                <div className="center">
                    {userLevels.userLevel !== AGENT_LEVEL ? (
                        <>
                            {"In order to see user details, you must "}
                            <a
                                className="emulation"
                                xd-qa-type="button"
                                xd-qa-name="Emulation"
                                onClick={() => emulationModal.show()}
                            >
                                {userLevels.userLevel === COMPANY_LEVEL ? (
                                    "Select Office & User"
                                ) : (
                                    "Select User"
                                )}
                            </a>
                        </>
                    ) : (
                        "Something went wrong"
                    )}
                </div>
            )}
        </div>
    )
);

const ADMIN_NOT_ALLOWED = 'This user does not allow admins to post to their social media accounts on their behalf.'
const ADMIN_ALLOWED = 'This user allows admins to post to their social media accounts on their behalf.'

const MESSAGE_VIEW_METRICS = 'To view metrics pertaining to your posts on different social media ' 
    + 'platforms, simply select the corresponding social media icon below'
